module.exports = __webpack_public_path__ + "media/src/site/images/phone-book-41c5cf0ebdc8e059dde9b96084961964.svg";